import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./styles/designTokens.css";
import "./App.scss";
import ExperiencePage from "./pages/ExperiencePage";
import HomePage from "./pages/HomePage";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import EmbedPage from "./pages/EmbedPage";
import JoinPage from "./pages/JoinPage";

const theme = createTheme({
  typography: {
    fontFamily: '"area-normal", sans-serif',
    h4: {
      fontFamily: '"area-normal", sans-serif',
      fontSize: "1.55rem",
      fontWeight: 900,
      lineHeight: 1.5,
    },
    h5: {
      fontFamily: '"area-normal", sans-serif',
      fontSize: "1.2rem",
      fontWeight: 900,
      lineHeight: 1.6,
    },
    body1: {
      lineHeight: 1.4,
    },
    caption: {
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: 1.4,
      display: "block",
    },
    overline: {
      fontFamily: '"area-normal", sans-serif',
      fontSize: "0.65rem",
      fontWeight: 400,
      textTransform: "uppercase",
      lineHeight: 2.0,
      color: "#999",
    },
  },
});
const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/join" element={<JoinPage />} />
          <Route path="/j/:code" element={<JoinPage />} />
          <Route
            path="/experiences/:experienceId"
            element={<ExperiencePage />}
          />
          <Route
            path="/experiences/embed/:experienceId"
            element={<EmbedPage />}
          />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
